module.exports = "/_next/static/images/92c223ac0e4f1d37df03560d1e7d1c7c-att-icon.svg.webp";